import { useMemo } from 'react';
import Fuse, { FuseOptionKeyObject } from 'fuse.js';

export function useGenericFuzzyFiltering<T extends Record<string, unknown>>(
  items: T[],
  fuzzyFilter: string,
  keys: FuseOptionKeyObject<T>[],
  threshold: number = 0.3,
) {
  const fuse = useMemo(() => {
    const fuseOptions = {
      keys,
      threshold,
      ignoreLocation: true,
      includeScore: true,
    };

    return new Fuse(items, fuseOptions);
  }, [items, keys, threshold]);

  const filteredItems = useMemo(() => {
    return fuzzyFilter
      ? fuse.search(fuzzyFilter).map((result) => result.item)
      : items;
  }, [fuse, fuzzyFilter, items]);

  return filteredItems;
}
